import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { Nav } from '@softwaredev_cegeka/stix-core'
import { reverse } from 'src/routes/config'
import './contentNav.scss'

class ContentNav extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        contentNavItems: PropTypes.array.isRequired,
        children: PropTypes.node,
    }

    render() {
        const { title, contentNavItems, children } = this.props

        return (
            <>
                <h1 className="content-navigation-title">{title}</h1>
                <div className="content-nav-root">
                    <Nav className="content-nav" variant="material">
                        {contentNavItems &&
                            contentNavItems.map((item, index) => (
                                <Nav.Item key={`${item.name}-${index}`}>
                                    <Nav.Link
                                        as={NavLink}
                                        to={reverse(item.link)}
                                        eventKey={item.index}
                                    >
                                        {item.name}
                                    </Nav.Link>
                                </Nav.Item>
                            ))}
                    </Nav>
                    {children}
                </div>
            </>
        )
    }
}

export default ContentNav
